import { useQuery } from "@tanstack/react-query";
import {
  locationAuditService,
  GetLocationAuditsParams,
  GetInventoriesByLocationParams,
} from "./location-audit.services";
import { LOCATION_AUDIT_KEYS } from "./keys";

export const useGetLocationAudits = (params?: GetLocationAuditsParams) => {
  return useQuery({
    queryKey: LOCATION_AUDIT_KEYS.GET_AUDITS(params),
    queryFn: () => locationAuditService.getAudits(params),
  });
};

export const useGetLocationAudit = (id?: string) => {
  return useQuery({
    queryKey: LOCATION_AUDIT_KEYS.GET_AUDIT(id!),
    queryFn: () => locationAuditService.getAudit(id!),
    enabled: !!id,
  });
};

export const useGetInventoriesByLocation = (
  locationId?: string,
  params?: GetInventoriesByLocationParams
) => {
  return useQuery({
    queryKey: LOCATION_AUDIT_KEYS.GET_INVENTORIES_BY_LOCATION(
      locationId!,
      params?.page,
      params?.limit
    ),
    queryFn: () =>
      locationAuditService.getInventoriesByLocation(locationId!, params),
    enabled: !!locationId,
  });
};
